import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { axiosInstance } from "@retro-ia/shared/axios";

interface SendActivationEmailsResponse {
  exitosos: string[];
  errores: string[];
}

interface UseSendActivationEmailsOptions {
  queryKey?: unknown[];
  onSuccess?: (data: SendActivationEmailsResponse) => void;
}

export const useSendActivationEmails = (
  options?: UseSendActivationEmailsOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (aprendicesIds: number[]) => {
      const { data } = await axiosInstance.post<SendActivationEmailsResponse>(
        "/aprendices/enviar-correos-activacion",
        { aprendicesIds },
      );
      return data;
    },
    onSuccess: (data) => {
      if (data.exitosos.length > 0) {
        toast.success(
          `✅ Correos enviados exitosamente a ${data.exitosos.length} usuario(s)`,
          {
            description: data.exitosos.join(", "),
            duration: 5000,
          },
        );
      }
      if (data.errores.length > 0) {
        toast.warning(`⚠️ ${data.errores.length} error(es) encontrado(s)`, {
          description: data.errores.join(" | "),
          duration: 7000,
        });
      }
      if (data.exitosos.length === 0 && data.errores.length === 0) {
        toast.info("No se enviaron correos");
      }
      if (options?.queryKey) {
        queryClient.invalidateQueries({ queryKey: options.queryKey });
      }
      if (options?.onSuccess) {
        options.onSuccess(data);
      }
    },
    onError: (error) => {
      toast.error("Error al enviar correos de activación");
      console.error("Error sending activation emails:", error);
    },
  });
};
